export enum AnswerTypeIdEnum {
  'same' = 1,
  'input',
}
